module.exports = __webpack_public_path__ + "img/Villa_Borna_53.812b218d.jpg";